







































import { Component, Prop } from "vue-property-decorator";
import { requiredRule } from "@/lib/rules/requiredRule.ts";
import { emailRule } from "@/lib/rules/contactRule.ts";
import AuthService from "@/services/mrfiktiv/services/authService";
import LoginMixin from "@/mixins/LoginMixin.vue";
import { LoginCardEnum } from "@/store/enum/loginCardEnum";

@Component({
  components: {}
})
export default class LoginForgotPassword extends LoginMixin {
  @Prop()
  changePasswordCard!: Function;

  @Prop()
  changeMail!: Function;

  submitted = false;
  isFormValid = typeof this.mail === typeof undefined;

  get emailRules() {
    return [requiredRule(), emailRule()];
  }

  constructor() {
    super();
  }

  get isResetButtonDisabled() {
    if (!this.isFormValid) {
      return true;
    }
    if (this.submitted) {
      return true;
    }
    return false;
  }

  backToLogin() {
    this.changeMail(this.mail);
    this.changeCard(LoginCardEnum.LOGIN);
  }

  async submit() {
    this.changeMail(this.mail);
    try {
      await AuthService.forgotPassword({ username: this.mail });
      this.submitted = true;
      this.setSuccessMessage(() => this.changeCard(LoginCardEnum.RESET));
    } catch (error) {
      this.failure = true;
      this.$log.error(error);
    }
  }
}
